var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"trend-content"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"first"},[_vm._v("\n      "+_vm._s(_vm.trend_main_title_)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"second"},[_c('highcharts',{attrs:{"options":_vm.options}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-273360f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trend.vue
// module id = null
// module chunks = 